<template>
    <div class="node-item"
         ref="node"
         :style="flowNodeContainer"
         @contextmenu.prevent="contextmenu"
         @mouseup="changeNodeSite"
         >
         <!-- @click.stop="editNode" -->
        <div class="node-con"><i :class="iconClass" class="type-icon"></i><span>{{node[flowMain.dataFormat.node.name]}}</span></div>
        
    </div>
</template>

<script>
    export default {
      name: 'flowNode',
      inject: ['flowMain'],
      props: {
        node: Object,
        // 当前 节点 编辑 类型
        editType: String,
        // 右菜单的 位置
        canvasMenuPositionObj: Object,
       // 右菜单 是否显示
        canvasMenuViasble: Boolean,
       // 传给 右菜单的 参数
        parameterLine: Object
      },
      computed: {
        // 节点容器样式
        flowNodeContainer: {
          get () {
            return {
              position: 'absolute',
              minWidth: '108px',
              top: this.node[this.flowMain.dataFormat.node.top] + 'px',
              left: this.node[this.flowMain.dataFormat.node.left] + 'px'
            }
          }
        },
        iconClass () {
          let currenNode = this.flowMain.menueList.find(item => item.standard === this.node[this.flowMain.dataFormat.node.standard])
          if (!currenNode) {
            currenNode = this.flowMain.menueList.find(item => item.nodetype === this.node[this.flowMain.dataFormat.node.nodetype])
          }
          let isConnectClass = this.flowMain.readerOnly ? '' : 'flow-node-drag'
          // 事项办结不能连接其他节点
          isConnectClass = currenNode.standard === 1003 ? '' : 'flow-node-drag'
          let iconClass = currenNode && currenNode.icon
          return [ iconClass, isConnectClass ]
        }
      },
      methods: {
        contextmenu (event) {
          // 做一次清空
          this.$emit('update:node_standard_code', null)
          this.$emit('update:editType', 'node')
          this.$emit('update:canvasMenuPositionObj', {left: event.pageX, top: event.pageY})
          this.$emit('update:canvasMenuViasble', true)
          this.$emit('update:node_standard_code', this.node[this.flowMain.dataFormat.node.standard])
          this.$emit('update:parameterLine', {node_id: this.node[this.flowMain.dataFormat.node.sourceId]})
        },
        // 鼠标移动后抬起
        changeNodeSite (event) {
          if (event.button !== 2) {
            this.$emit('changeNodeSite', {
              nodeId: this.node[this.flowMain.dataFormat.node.sourceId],
              left: parseInt(this.$refs.node.style.left),
              top: parseInt(this.$refs.node.style.top)
            })
          }
        }
      }
    }
</script>
<style lang="less">
  @import url('../lib/less/flowNode.less');
</style>



// WEBPACK FOOTER //
// packages/yz-flow/src/flowNode.vue